<template>
  <div id="movement-item">
    <basic-card :class="'movement-card'">
      <div class="img-part col">
        <img
          :src="
            `/static/icons/boxes/${
              $variables.boxTypes[movement.box.type]
            }_box.svg`
          "
        />
      </div>
      <div class="box-code col">
        {{
          $t("movementsScreen.movementItem.code", {
            code: movement.box.code
          })
        }}
      </div>
      <div class="box-type col">
        {{
          $t("movementsScreen.movementItem.type", {
            type: $variables.boxTypes[movement.box.type]
          })
        }}
      </div>
      <div class="box-qr col">
        {{
          $t("movementsScreen.movementItem.qrCode", {
            qrCode: movement.box.QRNumber
          })
        }}
      </div>
    </basic-card>
    <div
      class="with-keyboard col"
      v-if="movement.withKeyBoard === 1 && movement.isMobile == 1"
    >
      <img src="/static/icons/keyboard.svg" />
    </div>
  </div>
</template>

<script>
export default {
  name: "MovementItem",
  props: {
    movement: {
      type: Object,
      required: true
    }
  },
  components: {},
  data: () => ({}),
  created() {},
  computed: {},
  methods: {}
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";
#movement-item {
  margin-bottom: 10px;
  position: relative;
  .movement-card {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    .img-part {
      img {
        height: 20px;
        width: 20px;
      }
    }
    .box-info {
      display: flex;
    }
    .col {
      font-size: 14px;
      font-weight: 550;
      margin-right: 10px;
      white-space: nowrap;
    }
  }
}
.with-keyboard {
  height: 30px;
  width: 30px;
  position: absolute;
  top: -10px;
  right: 0px;
  background: aliceblue;
  border-radius: 50%;
  padding: 3px;
  border: 1px solid $color-primary;
  img {
    width: 90%;
  }
}
</style>
